import React, { useState } from 'react';

const TELEGRAM_BOT_URL = 'https://t.me/NotreenVpnBot';

function LoginPage({ onLogin }) {
  const [code, setCode] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const codeDigits = Array.from({ length: 6 }, (_, index) => code[index] || '');
  const hasCode = code.length > 0;
  const isCodeComplete = code.length === 6;

  const changeCode = (event) => {
    setCode(event.target.value.replace(/\D/g, '').slice(0, 6));
    setError('');
  };

  const submit = async (event) => {
    event.preventDefault();

    if (!isCodeComplete) {
      return;
    }

    setIsLoading(true);
    setError('');

    try {
      await onLogin({ code });
    } catch (requestError) {
      const status = requestError.response?.status;
      setError(status === 401 ? 'Неверный код доступа.' : 'Не удалось выполнить вход.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <main className="access-page">
      <section className="access-layout">
        <BrandLogo />

        <form className="access-form" onSubmit={submit}>
          <p className="access-copy">
            Чтобы получить доступ к сайту, необходим
            <br />
            <strong>шестизначный ключ</strong>, который выдаст вам <strong>Telegram бот</strong>
          </p>

          <label className="code-field" aria-label="Шестизначный ключ">
            <input
              autoComplete="one-time-code"
              inputMode="numeric"
              maxLength={6}
              value={code}
              onChange={changeCode}
              type="text"
            />
            <span className={`code-visual ${hasCode ? 'code-visual_with-separator' : ''}`} aria-hidden="true">
              <span className={codeDigits[0] ? '' : 'slot-dash'}>{codeDigits[0] || '—'}</span>
              <span className={codeDigits[1] ? '' : 'slot-dash'}>{codeDigits[1] || '—'}</span>
              <span className={codeDigits[2] ? '' : 'slot-dash'}>{codeDigits[2] || '—'}</span>
              {hasCode && <i />}
              <span className={codeDigits[3] ? '' : 'slot-dash'}>{codeDigits[3] || '—'}</span>
              <span className={codeDigits[4] ? '' : 'slot-dash'}>{codeDigits[4] || '—'}</span>
              <span className={codeDigits[5] ? '' : 'slot-dash'}>{codeDigits[5] || '—'}</span>
            </span>
          </label>

          {error && <p className="form-error">{error}</p>}

          {!hasCode ? (
            <a className="access-button" href={TELEGRAM_BOT_URL} rel="noreferrer" target="_blank">
              <svg className="telegram-icon" aria-hidden="true" viewBox="0 0 24 24" focusable="false">
                <path d="M21.7 3.6 18.4 20c-.2 1.1-.9 1.4-1.8.9l-5.1-3.8-2.5 2.4c-.3.3-.5.5-1 .5l.4-5.2 9.4-8.5c.4-.4-.1-.6-.6-.3L5.6 13.3.6 11.7c-1.1-.3-1.1-1.1.2-1.6L20.4 2.6c.9-.3 1.7.2 1.3 1Z" />
              </svg>
              <span>Получить ключ</span>
            </a>
          ) : (
            <button className="access-button" disabled={isLoading || !isCodeComplete} type="submit">
              <span>{isLoading ? 'Проверяем...' : 'Перейти на сайт'}</span>
              <span className="button-arrow" aria-hidden="true">→</span>
            </button>
          )}
        </form>
      </section>
    </main>
  );
}

export function BrandLogo() {
  return (
    <div className="brand-logo" aria-label="notreen.vpn">
      <img src="/logo.svg" alt="" />
      <span>notreen.vpn</span>
    </div>
  );
}

export default LoginPage;
